import { ApiProperty } from '@nestjs/swagger';
export class FilesDto {
    @ApiProperty({ type: 'file', format: 'binary' })
    file: string;
}
export class DocumentUploadDto {
    @ApiProperty()
    documentsListId: number[];
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    documentCategory: string;
    @ApiProperty({ type: [FilesDto]})
    filesDto: FilesDto[];
}
